const sensorLng = [
  { type: 'required', message: 'Sensor Longitude is required' },
  { type: 'pattern', message: 'Sensor Longitude must contain numbers' },
  { type: 'minlength', message: 'Sensor Longitude must have at least 10 digits' },
  { type: 'maxlength', message: 'Sensor Longitude must be at most of 17 digits' }
]

export default {
  sensorLng
}
